import { render, staticRenderFns } from "./OffersViewStoragesTable.vue?vue&type=template&id=c83905e2"
import script from "./OffersViewStoragesTable.vue?vue&type=script&lang=js"
export * from "./OffersViewStoragesTable.vue?vue&type=script&lang=js"
import style0 from "./OffersViewStoragesTable.vue?vue&type=style&index=0&id=c83905e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports